import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './UpgradeSuccessPage.css';

const PLAN_DETAILS = {
  starter: { name: 'Starter', price: '$49/month', deals: '5 active deals', icon: '⭐' },
  pro:     { name: 'Pro',     price: '$99/month', deals: 'Unlimited deals', icon: '🚀' },
};

export default function UpgradeSuccessPage() {
  const [params] = useSearchParams();
  const plan = params.get('plan') || 'starter';
  const details = PLAN_DETAILS[plan] || PLAN_DETAILS.starter;
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => setDots(d => d.length >= 3 ? '' : d + '.'), 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="success-page">
      <div className="success-card fade-up">
        <div className="success-icon">{details.icon}</div>
        <h1 className="font-display success-title">Welcome to {details.name}!</h1>
        <p className="success-sub">Your payment was successful. Your account has been upgraded.</p>

        <div className="success-plan-box">
          <div className="spb-row">
            <span>Plan</span>
            <strong>{details.name}</strong>
          </div>
          <div className="spb-row">
            <span>Billing</span>
            <strong>{details.price}</strong>
          </div>
          <div className="spb-row">
            <span>Active deals</span>
            <strong>{details.deals}</strong>
          </div>
          {plan === 'pro' && (
            <div className="spb-row">
              <span>Featured placement</span>
              <strong>✓ Included</strong>
            </div>
          )}
        </div>

        <p className="success-note">
          Your dashboard is updating{dots} It may take a moment for your new plan to appear.
        </p>

        <div className="success-actions">
          <Link to="/business/dashboard" className="btn btn-primary btn-lg">Go to dashboard →</Link>
          <Link to="/business/deals/new" className="btn btn-outline btn-lg">Create a deal</Link>
        </div>
      </div>
    </div>
  );
}
